<template> 
    <div>
        <div :id="id" style="width:100%; height:350px;"></div>
    </div>
</template>

<script type="text/javascript">


import { Observable, Subject  } from 'rxjs' 
import { debounceTime } from 'rxjs/operators';

import Big from 'big.js';
import * as Enumerable from "linq";
import echarts from "echarts";

import { formatDate } from 'element-ui/src/utils/date-util'

import { uuid8 } from "@/util/common";
import { httpUtil } from '@/util'

import { AuthInfo } from "@/util/user/authInfo"

export default {
    name: 'pue.report.pue.hour.linecharts',
    components:{
    },
    props: {
        systemHoursDataCurrent:Array,
        systemHoursDataLast   :Array,
        startTime : Date,
        endTime   : Date,
        roomIds   : [ Array, Object, String, Number ],
        hourDataSimilarWorkConditionRanks : Array,
        title : {
            type: String,
            default() {
                return "采集PUE,历史相似工况排名趋势";
            }
        }
    },    
    data: () => {
        return {
            hoursDataChagneObserver : new Subject(),
            hourDataSimilarWorkConditionRankChangeObserver : new Subject(),
            hourData:[],
            hourDataSimilarWorkConditionRankCurrent:[],
            hours:[],
            id : uuid8(),
            echartsSystemPUEClickObserver : new Subject(),
        };
    },
    mounted: function () {
    
        const me = this;
        
        me.renderEcharts();
        
        me.hoursDataChagneObserver.pipe( debounceTime(200) ).subscribe(
            ( newValue ) => {             
                me.handleHoursDataChagne();
            }
        );
        
        me.hourDataSimilarWorkConditionRankChangeObserver.pipe( debounceTime(200) ).subscribe(
            ( newValue ) => {             
                me.handleHourDataSimilarWorkConditionRankChange();
            }
        );
        
        me.echartsSystemPUEClickObserver.pipe( debounceTime(200) ).subscribe(
            ( params ) => {             
                me.handleEchartsSystemPUEClick( params );
            }
        );
    },
    watch: {

        systemHoursDataCurrent: {
        
            handler: function(newValue, oldValue) {
                
                const me = this;
                
                me.hoursDataChagneObserver.next( newValue );
            },
        },
        systemHoursDataLast: {
        
            handler: function(newValue, oldValue) {
                
                const me = this;
                
                me.hoursDataChagneObserver.next( newValue );
            },
        },
        hourDataSimilarWorkConditionRanks: {
        
            handler: function(newValue, oldValue) {
                
                const me = this;
                
                me.hourDataSimilarWorkConditionRankChangeObserver.next( newValue );
            },
        }
    },
    computed: {
    },
    methods: {
        handleSizeChange(val) {
                        
            const me = this;
        },
        handleEchartsSystemPUEClick(params){
            
            const me = this;
            
            if( params.name ){
                let endTime   = new Date( params.name );
                let startTime = new Date( endTime.getTime() - ( 1000 * 60 * 60 ) );
                
                let sp = [
                    {
                        "roomIds"   : me.roomIds,
                        "startTime" : startTime.getTime(),
                        "endTime"   : endTime.getTime()
                    }
                ];
                sp = httpUtil.json2EncodeString( sp );
                
                window.open("report/pointInTime?queryString=" + sp, "_blank"); 
            }
        },
        handleHourDataSimilarWorkConditionRankChange(){
        
            const me = this;
            
            me.hourDataSimilarWorkConditionRankCurrent = [];
            
            me.hourDataSimilarWorkConditionRankCurrent = Enumerable.from( me.hourDataSimilarWorkConditionRanks ).select(
                ( item,index ) => { 
                    return item.rank ? item.rank : 0
                }
            ).toArray();
            
            me.renderEcharts();
        },
        handleHoursDataChagne(){
            
            const me = this;
            
            let endTime = me.endTime ? me.endTime.getTime() : 0;
            
            let hourData = [];
            hourData = hourData.concat( me.systemHoursDataLast    );
            hourData = hourData.concat( me.systemHoursDataCurrent );
            
            hourData = Enumerable.from( hourData )
            .orderBy( (item)=>{ return item.tsdate } ).thenBy( (item)=>{ return item.recordpointId } )
            .toArray();
            
            me.hourData = Enumerable.from( hourData ).select(
                ( item,index ) => { 
                    return item.puePhase ? item.puePhase : 0
                }
            ).toArray();
                
            me.hours = Enumerable.from( hourData ).select(
                 ( item,index ) => { 
                    let returnTime = null;
                    if( item.tsdate ){
                        let recordpointId = item.recordpointId ? item.recordpointId : 0 ;
                        returnTime = formatDate( item.tsdate + 3600000*recordpointId , "yyyy-MM-dd HH:mm:ss" );
                    }
                    return returnTime
                 }   
            ).toArray();   
            
            me.renderEcharts();
        },
        renderEcharts(){
        
            const me = this;
        
            var myChart = echarts.init(document.getElementById( me.id ));
            
            myChart.on(
                'click', 
                function (params) {
                    if( params.seriesName == "采集PUE" ){
                        me.echartsSystemPUEClickObserver.next(params);
                    }
                }
            );
            let option = {
            	title: {
            		text: ""
            	},
            	grid: {
            	    top    : 80,
                    bottom : 60,
                    left   : 100,
                    right  : 100
                },
            	tooltip: {
            		trigger: 'axis',
            		axisPointer: { // 坐标轴指示器，坐标轴触发有效
            			type: 'line' // 默认为直线，可选为：'line' | 'shadow'
            		}
            	},
            	legend: {
            		data: [
            		    {
            		        name:'采集PUE',
            		    },
            		    {
            		        name:'历史工况排名',
            		    },
            		    {
            		    	name: 'PUE排名在历史相似工况前20%',
            		    	icon: 'bar'
            		    }, {
            		    	name: 'PUE排名在历史相似工况后80%',
            		    	icon: 'bar'
            		    }
            		],
            		selected: {
            		    '采集PUE':true,
            		    '历史工况排名':true,
            			'PUE排名在所有相似工况前20%': true,
            			'PUE排名在所有相似工况后80%': true,
            		}
            	},
                dataZoom : [
                    {
                        show : true,
                        realtime : true
                    },
                    {
                        type: 'slider',
                        yAxisIndex:0,
                        orient:'vertical',
                        left : 10
                    },
                    {
                        type: 'slider',
                        yAxisIndex:1,
                        orient:'vertical'
                    }
                ],
            	xAxis: {
            		//nameLocation: 'center',
            		type: 'category',
            		boundaryGap: true,
            		data: me.hours, //me.hourData,
            	},
                yAxis: [
                    {
                        type: 'value',
                        name: '历史工况排名(%)',
                        max: 100,
                        min: 0
                    },
                    {
                        type: 'value',
                        name: 'PUE',
                        max: 3,
                        min: 1
                    },
                ],
            
            	series:[ 
            	    {
            	        name:'采集PUE',
            		    type:'line',
            			data: me.hourData,
                        yAxisIndex:1
            		},
            		{
            		    name:'历史工况排名',
            		    type:'line',
            			data: me.hourDataSimilarWorkConditionRankCurrent,
            		},
                    {
            			name: 'PUE排名在所有相似工况前20%',
            			type: 'line',
            			animation: false,
            			color: '#81b22f',
            			areaStyle: {
            				normal: {}
            			},
            			lineStyle: {
            				normal: {
            					width: 1
            				}
            			},
            			markArea: {
            				data: [
            					[
            					    {
            						    yAxis: '0'
            					    }, {
            						    yAxis: '20'
            					    }
            					]
            				]
            			}
            		}, {
            			name: 'PUE排名在所有相似工况后80%',
            			type: 'line',
            			animation: false,
            			color: '#f4b9a9',
            			areaStyle: {
            				normal: {}
            			},
            			lineStyle: {
            				normal: {
            					width: 1
            				}
            			},
            			markArea: {
            				data: [
            					[{
            						yAxis: '100'
            					}, {
            						yAxis: '80'
            					}]
            				]
            			}
            		}
            	],
            }
  	        
            myChart.setOption(option);
        }
    }
}

</script>